// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__GMn2t","slogan":"Logo_slogan__6xCQA","title":"Logo_title__MRIGO","subtitle":"Logo_subtitle__lJDtN"};